// extracted by mini-css-extract-plugin
export default {"title":"each-food_title__A5FdY","foodEditButton":"each-food_foodEditButton__ql0UT"};